import { conditionFilter } from "@@/shared/discounts/conditions/discount-condition-filter";
import type { OrderItem } from "@@/shared/orders/order-items/order-item";
import { subtractFromPrice } from "@@/shared/prices/subtract-from-price";
import { sumPrices } from "@@/shared/prices/sum-prices";
import { repeat } from "@@/utilities/repeat";
import { sortBy } from "@@/utilities/sort";
import type { DiscountCalculator } from "../discount-calculator-type";
import type { StaggerDiscount } from "./stagger-discount";

const staggerDiscountCalculator: DiscountCalculator<StaggerDiscount> =
    (discount: StaggerDiscount) => (items: OrderItem[]) => {
        const entitledItems = conditionFilter(discount, items);

        // Find price in stagger discount data
        const pricePerItem =
            discount.steps
                .sort(sortBy(step => step.numberOfItems, "DESCENDING"))
                .find(step => step.numberOfItems >= entitledItems.length)
                ?.price ?? discount.startingPrice;

        // Calculate discount price
        const defaultPrice = sumPrices(
            entitledItems.map(item => item.pricePerItem),
        );
        const newPrice = sumPrices(repeat(pricePerItem, entitledItems.length));
        const discountPrice = subtractFromPrice(defaultPrice, [newPrice]);
        return discountPrice;
    };

export { staggerDiscountCalculator };
